import { Link } from "react-router-dom";
import { Target, Telescope, Plus, ArrowRight, Mail } from "lucide-react";
import Reveal from "../components/Reveal";
import { Eyebrow, PrimaryBtn } from "../components/Flow";

const CONNECT = ["Colombian manufacturers", "Caribbean developers", "Construction projects", "International logistics"];

export default function About() {
  return (
    <main data-testid="about-page">
      <section className="bg-[#0B132B] py-20 text-white sm:py-28 grain-overlay relative">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          <Reveal>
            <Eyebrow dark>About BUY CARIBBEAN</Eyebrow>
            <h1 className="mt-5 max-w-3xl font-display text-3xl font-extrabold tracking-tight sm:text-4xl lg:text-5xl" data-testid="about-headline">
              A new way to connect Colombia and the Caribbean.
            </h1>
            <p className="mt-6 max-w-2xl text-sm leading-relaxed text-white/65 sm:text-base md:text-lg">
              BUY CARIBBEAN was created around a simple idea: Caribbean construction projects need better access to reliable products, suppliers and procurement solutions.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="py-20 sm:py-28">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          <div className="grid gap-14 lg:grid-cols-2 lg:items-center">
            <Reveal>
              <Eyebrow>What We Connect</Eyebrow>
              <div className="mt-8 space-y-0" data-testid="about-connect-list">
                {CONNECT.map((c, i) => (
                  <div key={c}>
                    <div className="flex items-center gap-4 border border-[#0B132B]/12 bg-white px-6 py-5">
                      <span className="font-display text-sm font-extrabold text-[#0D9488]">0{i + 1}</span>
                      <p className="font-display text-base font-bold tracking-wide">{c}</p>
                    </div>
                    {i < CONNECT.length - 1 && (
                      <div className="flex justify-center py-1">
                        <Plus className="h-4 w-4 text-[#D97706]" />
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </Reveal>
            <Reveal delay={150}>
              <p className="text-sm leading-relaxed text-[#0B132B]/75 sm:text-base">
                Our ambition is to evolve from a sourcing and export company into a technology-enabled procurement partner for Caribbean construction and real estate.
              </p>
              <p className="mt-5 text-sm leading-relaxed text-[#0B132B]/75 sm:text-base">
                We work at the intersection of real estate intelligence, Colombian manufacturing and international logistics — so developers, builders and hospitality operators can focus on building, not on chasing suppliers.
              </p>
              <div className="mt-10 grid gap-5 sm:grid-cols-2">
                <div className="border border-[#0B132B]/12 bg-white p-7" data-testid="about-mission-card">
                  <Target className="h-6 w-6 text-[#0D9488]" strokeWidth={1.6} />
                  <p className="mt-4 text-xs font-bold uppercase tracking-[0.2em] text-[#0B132B]/45">Mission</p>
                  <p className="mt-3 font-display text-sm font-semibold leading-relaxed">
                    Simplify the way Caribbean projects source, purchase and receive products from Colombia.
                  </p>
                </div>
                <div className="border border-[#0B132B]/12 bg-white p-7" data-testid="about-vision-card">
                  <Telescope className="h-6 w-6 text-[#0D9488]" strokeWidth={1.6} />
                  <p className="mt-4 text-xs font-bold uppercase tracking-[0.2em] text-[#0B132B]/45">Vision</p>
                  <p className="mt-3 font-display text-sm font-semibold leading-relaxed">
                    Become a reference partner for construction and hospitality procurement between Colombia and the Caribbean.
                  </p>
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      <section className="bg-[#0B132B] py-20 text-white sm:py-24 grain-overlay relative">
        <div className="mx-auto max-w-4xl px-5 text-center lg:px-8">
          <Reveal>
            <h2 className="font-display text-2xl font-bold tracking-tight sm:text-3xl" data-testid="about-cta-headline">
              Building between Colombia and the Caribbean?
            </h2>
            <p className="mx-auto mt-4 max-w-xl text-sm text-white/60">
              We'd like to hear about your project.
            </p>
            <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
              <PrimaryBtn to="/contact" testid="about-cta-submit" light>SUBMIT YOUR PROJECT</PrimaryBtn>
              <a href="mailto:contactbuycaribbean@gmail.com" data-testid="about-email-link" className="inline-flex items-center gap-2 rounded-full border border-white/30 px-7 py-3.5 text-sm font-bold tracking-[0.06em] text-white transition-colors hover:border-white hover:bg-white/5">
                <Mail className="h-4 w-4" /> contactbuycaribbean@gmail.com
              </a>
            </div>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
